export default "__VITE_ASSET__gG_QT4jF__"